<div fxLayout="row"
  fxLayoutAlign="start ">
  <div fxFlex="1 0 auto">
    <h1>Team</h1>
  </div>

  <div fxFlex="0 0 auto"
    class="actions">
    <a mat-flat-button
      color="primary"
      [routerLink]="['invite']">Invite team members</a>
  </div>


</div>

<mat-tab-group>
  <mat-tab label="Active">
    <p *ngIf="error$ | async">{{ error$ | async }}</p>
    <bar-loader [loading]="loading$ | async"></bar-loader>
    <data-list-table [config]="tableConfig"
      [link]="true"
      [dataSource]="staff"
      [sort]="(filter$ | async).order"
      [page]="page$ | async"
      (onSort)="sort($event)"
      (onPage)="paginate($event)"></data-list-table>
  </mat-tab>

  <mat-tab label="Invitations">
    <data-list-table [config]="inviteConfig"
      [link]="false"
      [dataSource]="invites"
      [sort]="(filter$ | async).order"
      (onSort)="sort($event)"
      (onPage)="paginate($event)">

      <invite-actions *dataListCellRenderer="'actions'; let row;"
        [id]="row.id"
        (cancel)="cancelInvite($event)"
        (resend)="resendInvite($event)"></invite-actions>
    </data-list-table>

  </mat-tab>

</mat-tab-group>